module.exports = __webpack_public_path__ + "media/images/webpage/hotels/93/facility-71d8ca5046b39e6711d70863d648634c.webp";